import type { ComponentProps } from 'react'
import FollowUp from '../../shared/FollowUp'

type FollowUpProps = ComponentProps<typeof FollowUp>

export default function Step8_FollowUp(props: FollowUpProps) {
  return <FollowUp {...props} />
}

